export const GridItem = {}

export default GridItem
